import { render } from "./MobileNavigation.vue?vue&type=template&id=b83ebba4&scoped=true"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"

import "./MobileNavigation.vue?vue&type=style&index=0&id=b83ebba4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b83ebba4"

export default script